import { getMenusSettings } from 'redux/actions/Menu/menu';

// GET /menu/settings carries the business metadata blob that holds GTMID and
// tracking. It is a business-level object surfaced on a menu response, so the
// nesting is not obvious; check every place it can appear rather than silently
// falling back to defaults, which looks like "the screen ignored my data".
const METADATA_PATHS = [
  (data) => data?.settings?.metadata,
  (data) => data?.metadata,
  (data) => data?.business?.metadata,
  (data) => data?.settings?.business?.metadata,
];

export const resolveMetadata = (data) => {
  for (const pick of METADATA_PATHS) {
    const found = pick(data);
    if (found && typeof found === 'object') {
      return found;
    }
  }
  if (process.env.NODE_ENV === 'development') {
    console.warn(
      '[tracking] no metadata found on the /menu/settings response; the form will show defaults. Response was:',
      data
    );
  }
  return null;
};

export const loadWebsiteSettings = () =>
  getMenusSettings().then((data) => ({
    settings: data?.settings ?? {},
    metadata: resolveMetadata(data),
  }));

// The website settings endpoint replaces the whole settings object, so the
// tracking save has to send back everything it loaded with only metadata
// changed. Mirrors how Settings.js builds its payload.
export const buildSettingsPayload = (settings, metadata) => {
  const payload = {
    ...settings,
    metadata: {
      ...(settings?.metadata ?? {}),
      ...metadata,
    },
  };
  delete payload.payment;
  return payload;
};
